import * as React from "react";
import { type IColumn } from "@fluentui/react";
import { type User, type Vehicle, type VehicleMovementPeriod } from "../../api";
import { observer } from "mobx-react";
import { computed, makeObservable } from "mobx";

export interface ListVehicleMovementPeriodItemCellProps {
    readonly period: VehicleMovementPeriod;
    readonly column: IColumn;
}

import { store } from "../../store";

@observer
export class ListVehicleMovementPeriodItemCell extends React.Component<ListVehicleMovementPeriodItemCellProps> {
    constructor(props: ListVehicleMovementPeriodItemCellProps) {
        super(props);
        makeObservable(this);
    }

    @computed private get user(): User | undefined {
        if (!this.props.period || !this.props.period.userId) {
            return;
        }
        return store.repositoryUsers.byId(this.props.period.userId);
    }

    @computed private get vehicle(): Vehicle | undefined {
        if (!this.props.period) {
            return;
        }
        return store.repositoryVehicles.byId(this.props.period.vehicleId);
    }

    public render(): JSX.Element {
        const { column } = this.props;
        switch (column.key) {
            case "eventId":
                return <span>MOV-{this.props.period?.eventId}</span>;
            case "vehicleSerialNumber":
                return <span>{this.vehicle?.serialNumber}</span>;
            case "userEmployeeId":
                return (
                    <span>
                        {this.user?.employeeId ??
                            store.i18n.t("listVehicleMovementPeriods.data.user.null")}
                    </span>
                );
            case "startTime":
                return <span>{store.i18n.formatDateTime(this.props.period.startTime, true)}</span>;
            case "stopTime":
                return <span>{store.i18n.formatDateTime(this.props.period.stopTime, true)}</span>;
            case "totalTime":
                return (
                    <span>
                        {store.i18n.formatDuration(
                            (this.props.period.stopTime.getTime() -
                                this.props.period.startTime.getTime()) /
                                1000,
                            true,
                        )}
                    </span>
                );
            default:
                return <></>;
        }
    }
}
